import { Button, DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUserTablePaymentApi extends Layout {
    buttonLock: Button;
    buttonRevoke: Button;
    buttonToggleActive: Button;
    buttonUnlock: Button;
    searchPanelUsers: SearchPanel;
    sourceUserSettings: DataSource;
    tableUsers: Table;
    textboxSearchDepartmentId: Textbox;
    textboxSearchId: Textbox;
    textboxSearchIsActive: Textbox;
    textboxSearchName: Textbox;
    textboxSearchTerminalId: Textbox;
}
